import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import {
  UserAlias,
  UserAliasService
} from "@onsip/common/services/api/resources/userAlias/user-alias.service";
import { VoicemailManagementService } from "@onsip/common/services/api/resources/vmManager/vm-manager.service";
import { views } from "@onsip/web/app/phone/views";
import { combineLatest, Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";

@Component({
  selector: "onsip-vm-manager-link",
  templateUrl: "./vm-manager-link.component.html",
  styleUrls: ["./vm-manager-link.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class VmManagerLinkComponent implements OnInit, OnDestroy {
  views = views;
  extension$: Observable<string | undefined> = combineLatest({
    vmManager: this.vmManagerService.orgState.pipe(map(managers => managers[0])),
    extensions: this.userAliasService.orgState
  }).pipe(
    map(({ vmManager, extensions }) => {
      const vmManagerExtensions = extensions.filter(
        ({ addressId }) => addressId === vmManager?.addressId
      );

      if (!vmManagerExtensions.length) {
        return "";
      }

      const firstStarCode = this.firstStarCodeExtension(vmManagerExtensions);

      if (firstStarCode) {
        return firstStarCode.aliasUsername;
      }

      this.sortExtensions(vmManagerExtensions);

      return vmManagerExtensions[0]?.aliasUsername;
    })
  );

  private unsubscriber = new Subscription();

  constructor(
    private vmManagerService: VoicemailManagementService,
    private userAliasService: UserAliasService
  ) {}

  ngOnInit(): void {
    this.vmManagerService.voicemailManagementAddressBrowse();
  }

  ngOnDestroy(): void {
    this.unsubscriber.unsubscribe();
  }

  private firstStarCodeExtension(vmManagerExtensions: Array<UserAlias>): UserAlias | undefined {
    const starCodeExtensions = vmManagerExtensions.filter(extension =>
      extension.aliasUsername.startsWith("*")
    );
    this.sortExtensions(starCodeExtensions);

    return starCodeExtensions[0];
  }

  private sortExtensions(extensions: Array<UserAlias>): void {
    extensions.sort((ext1, ext2) => {
      const extAlias1 = this.getExtensionNumber(ext1);
      const extAlias2 = this.getExtensionNumber(ext2);

      return parseInt(extAlias1) - parseInt(extAlias2);
    });
  }

  private getExtensionNumber(extension: UserAlias): string {
    return extension.aliasUsername[0] === "*"
      ? extension.aliasUsername.slice(1)
      : extension.aliasUsername;
  }
}
